export const auth = {
  authHomeTitle: 'Добро пожаловать!',
  authHomeButtonBranded: 'Продолжить с Email',
  authHomeButtonApple: 'Продолжить с Apple',
  authHomeButtonGoogle: 'Продолжить с Google',
  authHomeButtonFacebook: 'Продолжить с Facebook',
  authHomeButtonLinkedin: 'Продолжить с LinkedIn',
  authStartTitle: 'Введите E-mail',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Введите правильный E-mail!',
  authStartInputPasswordError: 'Введите правильный Пароль!',
  authWhoops: 'Упс!',
  authStartConfirmButton: 'Продолжить',
  authRegisteredTitle: 'С возвращением!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Пароль',
  authRegisteredForgotPassword: 'Забыли пароль',
  authAlertIncorrectPassword: 'Ваш email или пароль неправильные',
  authAlertRequiredPassword: 'Введите правильный Пароль',
  authFinishSignUpTitle: 'Завершите регистрацию',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Имя',
  authFinishSignUpLastNameInputTitle: 'Фамилия',
  authFinishSignUpPasswordInputTitle: 'Пароль',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Мы рекомендуем использовать:</li><li class="list-disc">Минимум 8 символов</li><li class="list-disc">Как минимум 1 цифру</li><li class="list-disc">Как минимум 1 специальный символ</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Нажимая Зарегистрироваться, вы соглашаетесь с нашей',
    privacyPolicy: 'Политикой конфиденциальности',
    text2: 'и',
    termsOfUse: 'Условиями использования'
  },
  authFinishSignUpConfirmButton: 'Зарегистрироваться',
  authFinishSignUpErrorFirstName: 'Имя не может быть пустым!',
  authFinishSignUpErrorLastName: 'Фамилия не может быть пустой!',
  authFinishSignUpErrorPassword: 'Вы выбрали слишком короткий пароль!',
  authEmailConfirmationTitle: 'Проверьте свою электронную почту',
  authEmailConfirmationContent:
    'Мы отправили письмо с подтверждением, чтобы подтвердить ваш адрес электронной почты. Пожалуйста, проверьте свою папку со спамом, если не можете найти письмо в основной папке',
  authEmailConfirmationConfirmButton: 'Перейти на главный экран',
  authAlertEmailConfirmation: 'Вы всё ещё не подтвердили свой email - проверьте свою электронную почту!',
  authResetPasswordTitle: 'Проверьте свою электронную почту',
  authResetPasswordDescription:
    'Мы отправили ссылку для сброса пароля на ваш email. Пожалуйста, проверьте свою папку со спамом, если не можете найти письмо в основной папке',
  authResetPasswordButton: 'На главную',
  authNewPasswordTitle: 'Введите новый пароль',
  authNewPasswordInputTitle: 'Новый пароль',
  authNewPasswordButton: 'Сбросить пароль',
  authNewPasswordAlertValidation: 'Ваш пароль слишком лёгкий!',
  authPasswordChangeSuccessTitle: 'Пароль изменён!',
  authPasswordChangeSuccessContent: 'Вы успешно изменили свой пароль!',
  authPasswordChangeSuccessButton: 'На главную',
  authPasswordChangeErrorTitle: 'Произошла ошибка!',
  authPasswordChangeErrorContent: 'Что-то пошло не так при попытке сбросить ваш пароль! Попробуйте позже.',
  authPasswordChangeErrorButton: 'На главную',
  authInvitationTitle: 'Выберите себе пароль',
  authInvitationInputTitle: 'Пароль',
  authInvitationButton: 'Выбрать пароль',
  authEmailAddressConfirmed: 'Вы подтвердили свою почту!'
}
